import React from 'react';
import ProductImagesField from './ProductImagesField';

export default function ProductDetailsForm({
    name,
    onNameChange,
    description,
    onDescriptionChange,
    images,
    onImagesChange,
    onImageUploadLoadingChange,
    price,
    onPriceChange,
    hidePrice = false,
}) {
    return (
        <>
            <section className="shop-create-section">
                <label className="shop-create-label" htmlFor="product-name">
                    Название <b style={{ color: 'red' }}>*</b>
                </label>
                <input
                    id="product-name"
                    className="shop-create-input"
                    placeholder="например, Латте"
                    value={name}
                    onChange={(e) => onNameChange(e.target.value)}
                    autoComplete="off"
                />
            </section>

            <section className="shop-create-section">
                <label className="shop-create-label" htmlFor="product-description">
                    Описание
                </label>
                <textarea
                    id="product-description"
                    className="shop-create-input"
                    placeholder="Cостав, объём, особенности (необязательно)"
                    value={description}
                    onChange={(e) => onDescriptionChange(e.target.value)}
                    rows={4}
                    autoComplete="off"
                />
            </section>

            <ProductImagesField
                images={images}
                onChange={onImagesChange}
                onUploadLoadingChange={onImageUploadLoadingChange}
            />

            {!hidePrice ? (
                <section className="shop-create-section">
                    <label className="shop-create-label" htmlFor="product-price">
                        Цена <b style={{ color: 'red' }}>*</b>
                    </label>
                    <input
                        id="product-price"
                        className="shop-create-input"
                        placeholder="например, 199"
                        value={price}
                        onChange={(e) => onPriceChange(e.target.value)}
                        autoComplete="off"
                        inputMode="decimal"
                    />
                </section>
            ) : null}
        </>
    );
}
